import { getDefaultBoundingClientRect } from '@udecode/plate';

/**
 * Get bounding client rect of the window selection
 */
export const getSelectionBoundingClientRect = () => {
  let shadowRoot;
  if (window.appRootMountPoint) {
    const appRoot = window.appRootMountPoint;
    shadowRoot = appRoot.getRootNode();
  }
  const domSelection = shadowRoot ?
    shadowRoot.getSelection() : window.getSelection();

  if (!domSelection || domSelection.rangeCount < 1) {
    return getDefaultBoundingClientRect();
  }

  const domRange = domSelection.getRangeAt(0);

  return domRange.getBoundingClientRect();
};